import { css } from 'styled-components';
import { fadedBlue } from '../../../utils/customColors';

export const highlightedTextUnderlineStyles = css`
    background-image: linear-gradient(to right, ${fadedBlue}, ${fadedBlue});
    background-position: 0 0.8em;
    background-repeat: repeat-x;
`;
